export default [
    {
        path: '/haibotang',
        name: 'haibotang',
        component: () => import('../views/shopping/haiBoTangPage.vue'),
        meta: {
            hasTabbar: true,
            title: '海博堂'
        }
    },
    {
        path: '/productDetail',
        name: 'productDetail',
        component: () => import('../views/shopping/productDetail.vue'),
        meta: {
            title: '商品详情'
        }
    },
    {
        path: '/shopCar',
        name: 'shopCar',
        component: () => import('../views/shopping/shopCar.vue'),
        meta: {
            title: '购物车'
        }
    },
    {
        path: '/orderPage',
        name: 'orderPage',
        component: () => import('../views/shopping/orderPage.vue'),
        meta: {
            title: '确认订单'
        }
    },
    {
        path: '/address',
        name: 'address',
        component: () => import('../views/shopping/addressPage.vue'),
        meta: {
            title: '收货地址'
        }
    },
    {
        path: '/orderSuccess',
        name: 'orderSuccess',
        component: () => import('../views/shopping/orderSuccessPage.vue'),
        meta: {
            hasTabbar: true,
            title: '确认成功'
        }
    },

];